import { Typography } from '@material-ui/core';
import { Inline, Stack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { ReactElement } from 'react';
import { EmptySearchLoadsIcon } from 'shared/icons/EmptySearchLoadsIcon';
import styled from 'styled-components';
import { useLoadboardContext } from '../../data/LoadboardContext';

const Styled1 = styled.div`
  flex: 1;
  padding: 32px 16px;
`;

export function PrivatePostingListEmpty(): ReactElement {
  const { router } = useLoadboardContext();

  return (
    <Styled1>
      <Stack space="medium" align="center">
        <EmptySearchLoadsIcon />

        <Stack space="xsmall" align="center">
          <Typography variant="h3">No private loads yet</Typography>
          <Typography color="textSecondary">
            Meanwhile, explore a variety of options <br /> on Super Loadboard
            and stay ahead.
          </Typography>
        </Stack>

        <Inline space="small">
          <Button
            variant="primary"
            onClick={() => {
              router.openPostingsScreen('available');
            }}
          >
            Search All Available Loads
          </Button>
        </Inline>
      </Stack>
    </Styled1>
  );
}
